import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import alertService from '../../../services/AlertService';

/**
 * Returns admin courses page.
 * @returns admin courses page.
 */
const AdminCoursesPage: React.FC = () => {
    /*** HOOKS ***/

    const intl = useIntl();
    const [loading, setLoading] = useState<'loading'>();

    // initialize app
    useEffect(() => {
        const init = async () => {
            try {
                setLoading('loading');
            } catch (error) {
                alertService.displayError(error, intl);
            } finally {
                setLoading(undefined);
            }
        };
        init();
    }, [intl]);

    /*** METHODS ***/

    /*** VISUAL ***/

    return (
        <LayoutComponent title={<FormattedMessage id="adminCourses.title" />} menu="adminCourses">
            Courses{loading && '...'}
            <br />
        </LayoutComponent>
    );
};
export default AdminCoursesPage;
